import { convertTimestampToLuxonOrDefaultNow } from "../utils/convertTimestampToLuxonOrDefaultNow";
export const createCart = (data) => {
    assertCart(data, "save");
    return data;
};
export function assertCart(cart, mode = "load") {
    if (!cart || typeof cart !== "object") {
        throw new Error("Cart must be an object");
    }
}
export const createCartConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(cart) {
        assertCart(cart, "save");
        const data = {
            ...cart,
            refundedAt: cart.refundedAt !== null
                ? convertToFirestoreTimestampOrDefaultServerTime(cart.refundedAt)
                : null,
            createdAt: convertToFirestoreTimestampOrDefaultServerTime(cart.createdAt),
            apiVersion: 1,
        };
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        const cart = {
            ...data,
            id: snapshot.id,
            items: data.items || null,
            purchaseResults: data.purchaseResults || null,
            refundedAt: data.refundedAt !== null
                ? convertTimestampToLuxonOrDefaultNow(data.refundedAt)
                : null,
            createdAt: convertTimestampToLuxonOrDefaultNow(data.createdAt),
        };
        assertCart(cart);
        return cart;
    },
});
//# sourceMappingURL=Cart.js.map